import { useState } from 'react';
import { Eraser, Upload, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';
import { useToolUsage } from '@/hooks/useToolUsage';

const BackgroundRemover = () => {
  useToolUsage('background-remover');
  const [preview, setPreview] = useState('');
  const [file, setFile] = useState<File | null>(null);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (!f || !f.type.startsWith('image/')) { toast.error('Please upload an image'); return; }
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-xl bg-primary/20">
          <Eraser className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Background Remover</h1>
          <p className="text-muted-foreground">Remove image backgrounds instantly</p>
        </div>
      </div>

      <Card>
        <CardContent className="pt-6 space-y-4">
          {!file ? (
            <label className="block cursor-pointer">
              <div className="border-2 border-dashed border-border rounded-xl p-12 text-center hover:border-primary transition-colors">
                <Upload className="h-10 w-10 mx-auto mb-3 text-muted-foreground" />
                <p className="font-medium">Drop an image here or click to upload</p>
              </div>
              <input type="file" accept="image/*" onChange={handleUpload} className="hidden" />
            </label>
          ) : (
            <>
              <div className="aspect-video bg-muted rounded-lg overflow-hidden flex items-center justify-center">
                <img src={preview} alt="Preview" className="max-w-full max-h-full object-contain" />
              </div>
              <div className="p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg text-center">
                <p className="text-sm font-medium text-amber-600 dark:text-amber-400">🚧 Coming Soon</p>
                <p className="text-xs text-muted-foreground mt-1">
                  AI-powered background removal is under development. Stay tuned!
                </p>
              </div>
              <Button variant="outline" onClick={() => { setFile(null); setPreview(''); }}>Clear</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BackgroundRemover;
